var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blue-container level"},[_c('RewardDescription',{attrs:{"currentLevel":_vm.currentLevel,"rewardData":_vm.propsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }